import ApiService from "./ApiService";
export default class StoreService extends ApiService {
  constructor(endpointName) {
    super(endpointName);
  }

  getCompletionStatus(id) {
    const _url =
      this.serviceUrl +
      this.endpoints.getCompletionStatus.replace("{__id__}", id);
    return this.GET(_url);
  }

  getDashboardData(id) {
    const _url =
      this.serviceUrl + this.endpoints.dashboard.replace("{__id__}", id);
    return this.GET(_url);
  }

  getSubscriptionInfo(storeId) {
    const _url =
      this.serviceUrl +
      this.endpoints.subscriptionInfo.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }

  changeActiveStatus(id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.changeActiveStatus.replace("{__id__}", id);
    return this.PATCH(_url, data);
  }

  updateMenuStyle(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.updateMenuStyle.replace("{__storeId__}", storeId);
    return this.PATCH(_url, data);
  }

  getAllProducts(storeId) {
    const _url =
      this.serviceUrl +
      this.endpoints.allProducts.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }

  productBatch(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.productBatch.replace("{__storeId__}", storeId);
    return this.PUT(_url, data);
  }

  getProductAll(storeId) {
    const _url =
      this.serviceUrl +
      this.endpoints.productAll.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }

  getInfo(storeId) {
    const _url =
      this.serviceUrl + this.endpoints.info.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }

  updateInfo(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.updateInfo.replace("{__storeId__}", storeId);
    return this.PUT(_url, data);
  }

  editCategories(storeId, data, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.editCategories
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  createCategory(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.category.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  getCategory(storeId) {
    const _url =
      this.serviceUrl +
      this.endpoints.category.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }

  changeActiveStatusCategory(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.changeActiveStatusCategory
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PATCH(_url, data);
  }

  changeShowInMenuCategory(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.changeShowInMenuCategory
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PATCH(_url, data);
  }

  deleteCategories(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.deleteCategories
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.Delete(_url);
  }

  changeOrderCategory(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.changeOrderCategory
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PATCH(_url, data);
  }

  categoryIconList(storeId, { pageIndex, pageSize }) {
    let _url =
      this.serviceUrl +
      this.endpoints.categoryIconList.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  addImage(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.addImage.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  removeImage(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.removeImage.replace("{__storeId__}", storeId);
    return this.Delete(_url, data);
  }

  updateWorkSchedule(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.updateWorkSchedule.replace("{__storeId__}", storeId);
    return this.PATCH(_url, data);
  }

  subscriptionRenewal(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.subscriptionRenewal.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  subscriptionUpgrade(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.subscriptionUpgrade.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }
  subscriptionUpgradeDetails(storeId, subscriptionId) {
    let _url =
      this.serviceUrl +
      this.endpoints.subscriptionUpgradeDetails.replace(
        "{__storeId__}",
        storeId,
      );
    if (subscriptionId) {
      _url += "?subscriptionId=" + subscriptionId;
    }
    return this.POST(_url);
  }

  subscriptionHistory(storeId, { pageIndex, pageSize }) {
    let _url =
      this.serviceUrl +
      this.endpoints.subscriptionHistory.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  editProduct(storeId, data, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.editProduct
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  deleteProduct(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.deleteProduct
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.Delete(_url);
  }

  changeActiveStatusProduct(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.changeActiveStatusProduct
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PATCH(_url, data);
  }

  changeShowInMenuProduct(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.changeShowInMenuProduct
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PATCH(_url, data);
  }

  createProduct(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.product.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  getProduct(storeId, categoryId) {
    let _url =
      this.serviceUrl +
      this.endpoints.productbyCategory.replace("{__storeId__}", storeId);
    if (categoryId) {
      _url += "?categoryId=" + categoryId;
    }
    return this.GET(_url);
  }

  changeOrderProduct(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.changeOrderProduct.replace("{__storeId__}", storeId);
    return this.PATCH(_url, data);
  }

  changeSpecialStatusProduct(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.changeSpecialStatusProduct.replace(
        "{__storeId__}",
        storeId,
      );
    return this.PATCH(_url, data);
  }

  changeAvailableStatusProduct(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.changeAvailableStatusProduct.replace(
        "{__storeId__}",
        storeId,
      );
    return this.PATCH(_url, data);
  }
  createTicket(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.tickets.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }
  replyTicket(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.replyTicket
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.POST(_url, data);
  }
  changePassword(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.changePassword.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }
  closeTicket(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.closeTicket
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url);
  }
  getTickets(storeId, { pageIndex, pageSize }) {
    let _url =
      this.serviceUrl +
      this.endpoints.tickets.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  detailsTicket(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.detailsTicket
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.GET(_url);
  }

  sendingEconomicInfo(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.economicInfo.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  getEconomicInfo(storeId) {
    const _url =
      this.serviceUrl +
      this.endpoints.economicInfo.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }

  ordersCreate(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.ordersCreate.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  preInvoiceCreate(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.preInvoiceCreate.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  customersFind(storeId, phoneNumber) {
    let _url =
      this.serviceUrl +
      this.endpoints.customersFind.replace("{__storeId__}", storeId);
    if (phoneNumber) {
      _url += "?phoneNumber=" + phoneNumber;
    }
    return this.GET(_url);
  }

  createCustomer(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.customers.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  customersImportFromExcel(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.customersImportFromExcel.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  ordersPreorderFind(storeId, dailyNumber) {
    let _url =
      this.serviceUrl +
      this.endpoints.ordersPreorderFind.replace("{__storeId__}", storeId);
    if (dailyNumber) {
      _url += "?DailyNumber=" + dailyNumber;
    }
    return this.GET(_url);
  }

  ordersPreorderEdit(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.ordersPreorderEdit
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  ordersToday(
    storeId,
    {
      pageIndex,
      pageSize,
      isPreOrder,
      dailyOrderNumber,
      preparationStatus,
      paymentCompleted,
      isReturned,
      tableId,
      customerName,
    },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.ordersToday.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (isPreOrder || isPreOrder == false) {
      _url += "&isPreOrder=" + isPreOrder;
    }
    if (dailyOrderNumber) {
      _url += "&dailyOrderNumber=" + dailyOrderNumber;
    }
    if (preparationStatus || preparationStatus == 0) {
      _url += "&preparationStatus=" + preparationStatus;
    }
    if (paymentCompleted || paymentCompleted == false) {
      _url += "&paymentCompleted=" + paymentCompleted;
    }
    if (tableId) {
      _url += "&tableId=" + tableId;
    }
    if (customerName) {
      _url += "&customerName=" + customerName;
    }
    if (isReturned || isReturned == false) {
      _url += "&isReturned=" + isReturned;
    }
    return this.GET(_url);
  }

  updatePreparationStatus(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.updatePreparationStatus
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.POST(_url, data);
  }

  ordersHistory(
    storeId,
    {
      pageIndex,
      pageSize,
      date,
      paymentMethod,
      type,
      isReturned,
      storeOrderNumber,
    },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.ordersHistory.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (date) {
      _url += "&Date=" + date;
    }
    if (storeOrderNumber) {
      _url += "&StoreOrderNumber=" + storeOrderNumber;
    }
    if (paymentMethod || paymentMethod == 0) {
      _url += "&PaymentMethod=" + paymentMethod;
    }
    if (type || type == 0) {
      _url += "&Type=" + type;
    }
    if (isReturned || isReturned == false) {
      _url += "&IsReturned=" + isReturned;
    }
    return this.GET(_url);
  }

  orderReturn(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.orderReturn
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.POST(_url);
  }

  sendPrintOrderMessage(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.sendPrintOrderMessage
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.POST(_url);
  }

  getCustomers(
    storeId,
    {
      pageIndex,
      pageSize,
      phoneNumber,
      searchTerm,
      sortBy,
      levelNumber,
      sortDescending,
      minScore,
      maxScore,
      groupId,
      maxTotalOrdersCount,
      minTotalOrdersCount,
      maxTotalOrdersAmount,
      minTotalOrdersAmount,
      maxDaysNumberSinceLastOrdered,
      minDaysNumberSinceLastOrdered,
      favoriteProductId,
    },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.customers.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (phoneNumber) {
      _url += "&PhoneNumber=" + phoneNumber;
    }
    if (searchTerm) {
      _url += "&SearchTerm=" + searchTerm;
    }
    if (sortBy) {
      _url += "&SortBy=" + sortBy;
    }
    if (levelNumber) {
      _url += "&LevelNumber=" + levelNumber;
    }
    if (groupId) {
      _url += "&GroupId=" + groupId;
    }
    if (maxTotalOrdersCount) {
      _url += "&TotalOrdersCountRange.To=" + maxTotalOrdersCount;
    }
    if (minTotalOrdersCount) {
      _url += "&TotalOrdersCountRange.From=" + minTotalOrdersCount;
    }
    if (maxTotalOrdersAmount) {
      _url += "&TotalOrdersAmountRange.To=" + maxTotalOrdersAmount;
    }
    if (minTotalOrdersAmount) {
      _url += "&TotalOrdersAmountRange.From=" + minTotalOrdersAmount;
    }
    if (maxDaysNumberSinceLastOrdered) {
      _url +=
        "&DaysNumberSinceLastOrderedRange.To=" + maxDaysNumberSinceLastOrdered;
    }
    if (minDaysNumberSinceLastOrdered) {
      _url +=
        "&DaysNumberSinceLastOrderedRange.From=" +
        minDaysNumberSinceLastOrdered;
    }
    if (favoriteProductId) {
      _url += "&FavoriteProductId=" + favoriteProductId;
    }
    if (sortDescending || sortDescending == false) {
      _url += "&SortDescending=" + sortDescending;
    }
    if (minScore) {
      _url += "&ScoreRange.From=" + minScore;
    }
    if (maxScore) {
      _url += "&ScoreRange.To=" + maxScore;
    }
    return this.GET(_url);
  }

  editCustomer(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.editCustomer
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  editScoreCustomer(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.editScoreCustomer
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PATCH(_url, data);
  }

  ordersCustomer(storeId, id, { pageIndex, pageSize }) {
    let _url =
      this.serviceUrl +
      this.endpoints.ordersCustomer
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  orderOnlinePayments(
    storeId,
    { pageIndex, pageSize, status, transactionCode, storeOrderNumber },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.orderOnlinePayments.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (status || status == 0) {
      _url += "&Status=" + status;
    }
    if (transactionCode) {
      _url += "&TransactionCode=" + transactionCode;
    }
    if (storeOrderNumber) {
      _url += "&StoreOrderNumber=" + storeOrderNumber;
    }
    return this.GET(_url);
  }

  productSalesReport(
    storeId,
    { pageIndex, pageSize, type, from, to, sortAscending, productName },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.productSalesReport.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (productName) {
      _url += "&ProductName=" + productName;
    }
    if (type || type == 0) {
      _url += "&Type=" + type;
    }
    if (from) {
      _url += "&From=" + from;
    }
    if (to) {
      _url += "&To=" + to;
    }
    if (sortAscending || sortAscending == false) {
      _url += "&SortAscending=" + sortAscending;
    }
    return this.GET(_url);
  }

  orderDetails(storeId, id) {
    let _url =
      this.serviceUrl +
      this.endpoints.orderDetails
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.GET(_url);
  }

  orderDetailsStoreOrderNumber(
    storeId,
    { storeOrderNumber, dailyOrderNumber },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.orderDetailsStoreOrderNumber.replace(
        "{__storeId__}",
        storeId,
      );
    if (storeOrderNumber) {
      _url += "?storeOrderNumber=" + storeOrderNumber;
    }
    if (dailyOrderNumber) {
      _url += "?dailyOrderNumber=" + dailyOrderNumber;
    }
    return this.GET(_url);
  }

  ordersReport(
    storeId,
    {
      pageIndex,
      pageSize,
      from,
      to,
      customerPhoneNumber,
      transactionCode,
      orderId,
      storeOrderNumber,
      userId,
      paymentMethod,
      isReturned,
      hasTax,
      type,
    },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.ordersReport.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (from) {
      _url += "&From=" + from;
    }
    if (to) {
      _url += "&To=" + to;
    }
    if (customerPhoneNumber) {
      _url += "&CustomerPhoneNumber=" + customerPhoneNumber;
    }
    if (transactionCode) {
      _url += "&TransactionCode=" + transactionCode;
    }
    if (orderId) {
      _url += "&OrderId=" + orderId;
    }

    if (storeOrderNumber) {
      _url += "&StoreOrderNumber=" + storeOrderNumber;
    }
    if (userId) {
      _url += "&UserId=" + userId;
    }
    if (paymentMethod || paymentMethod == 0) {
      _url += "&PaymentMethod=" + paymentMethod;
    }
    if (isReturned || isReturned == false) {
      _url += "&IsReturned=" + isReturned;
    }
    if (hasTax || hasTax == false) {
      _url += "&HasTax=" + hasTax;
    }
    if (type || type == 0) {
      _url += "&Type=" + type;
    }
    return this.GET(_url);
  }

  getUsers(storeId, { pageIndex, pageSize }) {
    let _url =
      this.serviceUrl + this.endpoints.users.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  getUser(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.usersId
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.GET(_url);
  }

  createUser(storeId, data) {
    const _url =
      this.serviceUrl + this.endpoints.users.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  editUser(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.usersId
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  deleteUser(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.usersId
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.Delete(_url);
  }

  customersWalletTransactions(
    storeId,
    { pageIndex, pageSize, storeUserId, type, from, to, customerId },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.customersWalletTransactions.replace(
        "{__storeId__}",
        storeId,
      );
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (storeUserId) {
      _url += "&StoreUserId=" + storeUserId;
    }
    if (from) {
      _url += "&From=" + from;
    }
    if (to) {
      _url += "&To=" + to;
    }
    if (customerId) {
      _url += "&CustomerId=" + customerId;
    }
    if (type || type == 0) {
      _url += "&Type=" + type;
    }
    return this.GET(_url);
  }

  customersAddWalletBalance(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.customersAddWalletBalance.replace(
        "{__storeId__}",
        storeId,
      );
    return this.POST(_url, data);
  }

  customersSetWalletBalance(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.customersSetWalletBalance.replace(
        "{__storeId__}",
        storeId,
      );
    return this.POST(_url, data);
  }

  getLoyaltySystem(storeId) {
    let _url =
      this.serviceUrl +
      this.endpoints.loyaltySystem.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }

  loyaltySystem(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.loyaltySystem.replace("{__storeId__}", storeId);
    return this.PUT(_url, data);
  }

  requestEditSMS(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.smsSchedulesById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  smsSchedulesCancel(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.smsSchedulesCancel
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PATCH(_url);
  }

  getSmsSchedulesById(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.smsSchedulesById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.GET(_url);
  }

  smsSchedules(storeId, { pageIndex, pageSize, status, to, from }) {
    let _url =
      this.serviceUrl +
      this.endpoints.smsSchedules.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (status || status == 0) {
      _url += "&Status=" + status;
    }
    if (to) {
      _url += "&To=" + to;
    }
    if (from) {
      _url += "&From=" + from;
    }
    return this.GET(_url);
  }

  sendSMSSchedules(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.smsSchedules.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  getSmsManagement(storeId) {
    let _url =
      this.serviceUrl +
      this.endpoints.smsManagement.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }

  smsManagement(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.smsManagement.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  smsChargesHistory(storeId, { pageIndex, pageSize }) {
    let _url =
      this.serviceUrl +
      this.endpoints.smsChargesHistory.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  smsAccountRecharge(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.smsCharge.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  productPrinterStatus(storeId) {
    let _url =
      this.serviceUrl +
      this.endpoints.productPrinterStatus.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }

  systemKey(storeId) {
    let _url =
      this.serviceUrl +
      this.endpoints.printerCertificates.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }

  createPrinters(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.printers.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  createSystemKey(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.printerCertificates.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  printerSignatureMessage(storeId, id, message) {
    let _url =
      this.serviceUrl +
      this.endpoints.printerSignatureMessage
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    if (message) {
      _url += "?message=" + message;
    }
    return this.GET(_url);
  }

  printerCertificateKey(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.printerCertificateKey
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.GET(_url);
  }

  getPrinter(storeId) {
    const _url =
      this.serviceUrl +
      this.endpoints.printers.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }

  printerEditSystemKey(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.printerCertificatesId
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  printerDeleteSystemKey(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.printerCertificatesId
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.Delete(_url);
  }

  editPrinter(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.printersById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  deletePrinter(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.printersById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.Delete(_url);
  }

  getUserInfo(storeId) {
    const _url =
      this.serviceUrl +
      this.endpoints.userInfo.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }

  changeDefaultPrinter(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.changeDefaultPrinter.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  ordersForSyncPrint(storeId, lastDailyOrderNumber, lastPrinterId) {
    let _url =
      this.serviceUrl +
      this.endpoints.ordersForSyncPrint.replace("{__storeId__}", storeId);
    _url += "?lastDailyOrderNumber=" + lastDailyOrderNumber;
    _url += "&lastPrinterId=" + lastPrinterId;
    return this.GET(_url);
  }

  generalReports(storeId, from, to) {
    let _url =
      this.serviceUrl +
      this.endpoints.generalReports.replace("{__storeId__}", storeId);
    if (from) {
      _url += "?From=" + from;
    }
    if (to) {
      _url += "&To=" + to;
    }
    return this.GET(_url);
  }

  sentMessagesHistory(
    storeId,
    { pageIndex, pageSize, phoneNumber, dateRangeFrom, dateRangeTo },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.sentMessagesHistory.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (phoneNumber) {
      _url += "&PhoneNumber=" + phoneNumber;
    }
    if (dateRangeFrom) {
      _url += "&DateRange.From=" + dateRangeFrom;
    }
    if (dateRangeTo) {
      _url += "&DateRange.To=" + dateRangeTo;
    }
    return this.GET(_url);
  }

  getWarehousingCategories(storeId, { pageIndex, pageSize }) {
    let _url =
      this.serviceUrl +
      this.endpoints.warehousingCategories.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  warehousingCategories(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingCategories.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  editWarehousingCategories(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingCategoriesById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  warehousingMaterialsForProducts(storeId) {
    let _url =
      this.serviceUrl +
      this.endpoints.warehousingMaterialsForProducts.replace(
        "{__storeId__}",
        storeId,
      );
    return this.GET(_url);
  }

  getWarehousingMaterials(
    storeId,
    { pageIndex, pageSize, categoryId, searchTerm, warehouseId },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.warehousingMaterials.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (searchTerm) {
      _url += "&searchTerm=" + searchTerm;
    }
    if (warehouseId) {
      _url += "&warehouseId=" + warehouseId;
    }
    if (categoryId || categoryId == 0) {
      _url += "&categoryId=" + categoryId;
    }
    return this.GET(_url);
  }

  warehousingMaterials(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingMaterials.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  editWarehousingMaterials(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingMaterialsById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  getWarehousingWarehouses(storeId, { pageIndex, pageSize }) {
    let _url =
      this.serviceUrl +
      this.endpoints.warehousingWarehouses.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  warehousingWarehouses(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingWarehouses.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  editWarehousingWarehouses(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingWarehousesById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  getwarehousingWarehousesById(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingWarehousesById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.GET(_url);
  }

  warehousingPeople(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingPeople.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  editWarehousingPeople(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingPeopleById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  getwarehousingPeople(
    storeId,
    { pageIndex, pageSize, name, phoneNumber, role },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.warehousingPeople.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (name) {
      _url += "&name=" + name;
    }
    if (phoneNumber) {
      _url += "&phoneNumber=" + phoneNumber;
    }
    if (role || role == 0) {
      _url += "&role=" + role;
    }
    return this.GET(_url);
  }

  getwarehousingInvoicesById(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingInvoicesById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.GET(_url);
  }

  warehousingInvoices(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingInvoices.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  getWarehousingInvoices(
    storeId,
    {
      pageIndex,
      pageSize,
      type,
      personId,
      sourceWarehouseId,
      destinationWarehouseId,
      fromDate,
      toDate,
    },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.warehousingInvoices.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (type || type == 0) {
      _url += "&type=" + type;
    }
    if (personId) {
      _url += "&personId=" + personId;
    }
    if (sourceWarehouseId) {
      _url += "&sourceWarehouseId=" + sourceWarehouseId;
    }
    if (destinationWarehouseId) {
      _url += "&destinationWarehouseId=" + destinationWarehouseId;
    }
    if (fromDate) {
      _url += "&fromDate=" + fromDate;
    }
    if (toDate) {
      _url += "&toDate=" + toDate;
    }
    return this.GET(_url);
  }

  editWarehousingStockTakings(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingStockTakingsById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  getWarehousingStockTakings(
    storeId,
    { pageIndex, pageSize, number, warehouseId },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.warehousingStockTakings.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (number) {
      _url += "&Number=" + number;
    }
    if (warehouseId) {
      _url += "&WarehouseId=" + warehouseId;
    }
    return this.GET(_url);
  }

  getWarehousingStockTakingsById(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingStockTakingsById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.GET(_url);
  }

  warehousingStockTakings(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingStockTakings.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  warehousingStockTakingsFinalize(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingStockTakingsFinalize
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PATCH(_url);
  }

  deleteWarehousingStockTakings(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.warehousingStockTakingsById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.Delete(_url);
  }

  warehousingStockMovements(
    storeId,
    {
      pageIndex,
      pageSize,
      referenceNumber,
      from,
      to,
      type,
      reason,
      rawMaterialId,
      rawMaterialCategoryId,
      sourceWarehouseId,
      destinationWarehouseId,
    },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.warehousingStockMovements.replace(
        "{__storeId__}",
        storeId,
      );
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (referenceNumber) {
      _url += "&ReferenceNumber=" + referenceNumber;
    }
    if (from) {
      _url += "&From=" + from;
    }
    if (to) {
      _url += "&To=" + to;
    }
    if (type) {
      _url += "&Type=" + type;
    }
    if (reason) {
      _url += "&Reason=" + reason;
    }
    if (rawMaterialId) {
      _url += "&RawMaterialId=" + rawMaterialId;
    }
    if (rawMaterialCategoryId) {
      _url += "&RawMaterialCategoryId=" + rawMaterialCategoryId;
    }
    if (sourceWarehouseId) {
      _url += "&SourceWarehouseId=" + sourceWarehouseId;
    }
    if (destinationWarehouseId) {
      _url += "&DestinationWarehouseId=" + destinationWarehouseId;
    }
    return this.GET(_url);
  }

  customersScoreRecords(
    storeId,
    { pageIndex, pageSize, storeUserId, type, from, to, customerId },
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.customersScoreRecords.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (storeUserId) {
      _url += "&StoreUserId=" + storeUserId;
    }
    if (from) {
      _url += "&From=" + from;
    }
    if (to) {
      _url += "&To=" + to;
    }
    if (customerId) {
      _url += "&CustomerId=" + customerId;
    }
    if (type || type == 0) {
      _url += "&Type=" + type;
    }
    return this.GET(_url);
  }

  createCampaign(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.campaigns.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  getCampaigns(storeId, { pageIndex, pageSize, isActive, from, to }) {
    let _url =
      this.serviceUrl +
      this.endpoints.campaigns.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (from) {
      _url += "&From=" + from;
    }
    if (to) {
      _url += "&To=" + to;
    }
    if (isActive || isActive == false) {
      _url += "&IsActive=" + isActive;
    }
    return this.GET(_url);
  }

  getCampaignsById(storeId, id) {
    const _url =
      this.serviceUrl +
      this.endpoints.campaignsById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.GET(_url);
  }

  editCampaignsById(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.campaignsById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  campaignChangeStatus(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.campaignChangeStatus
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PATCH(_url, data);
  }

  getCampaignsActives(storeId) {
    const _url =
      this.serviceUrl +
      this.endpoints.campaignsActives.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }

  getCustomerCampaign(storeId, customerId) {
    const _url =
      this.serviceUrl +
      this.endpoints.customerCampaign
        .replace("{__storeId__}", storeId)
        .replace("{__customerId__}", customerId);
    return this.GET(_url);
  }

  getCustomerComments(storeId, { pageIndex, pageSize, status, from, to }) {
    let _url =
      this.serviceUrl +
      this.endpoints.customerComments.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (status || status == 0) {
      _url += "&Status=" + status;
    }
    if (from) {
      _url += "&From=" + from;
    }
    if (to) {
      _url += "&To=" + to;
    }
    return this.GET(_url);
  }

  customerCommentsStatus(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.customerCommentsStatus
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PATCH(_url, data);
  }

  customerCommentsSettings(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.customerCommentsSettings.replace("{__storeId__}", storeId);
    return this.PUT(_url, data);
  }

  getCustomerCommentsSettings(storeId) {
    let _url =
      this.serviceUrl +
      this.endpoints.customerCommentsSettings.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }

  getTables(storeId, { pageIndex, pageSize }) {
    let _url =
      this.serviceUrl + this.endpoints.tables.replace("{__storeId__}", storeId);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  editTable(storeId, id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.tablesById
        .replace("{__storeId__}", storeId)
        .replace("{__id__}", id);
    return this.PUT(_url, data);
  }

   createTable(storeId, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.tables.replace("{__storeId__}", storeId);
    return this.POST(_url, data);
  }

  tablesActive(storeId) {
    let _url =
      this.serviceUrl +
      this.endpoints.tablesActive.replace("{__storeId__}", storeId);
    return this.GET(_url);
  }
}
